import {KeyLabel} from './key-label.model';
export enum DeliveryFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}
export const DeliveryFrequencyLabels = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};
export const DeliveryFrequencyLabelsKL = () => (Object.keys(DeliveryFrequencyLabels)
  .map(key => new KeyLabel<DeliveryFrequency>(DeliveryFrequency[key], DeliveryFrequencyLabels[key])));
